import React, { useState, useEffect } from "react";
import FeedNewCard from "./FeedNewCard";
import { fetchTrendingNews } from "../../../api/feed/feedAPI";
import LoadingPlaceholder from "../../../components/ui/loading/LoadingPlaceholder";

function TrendingNewsList() {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadAllTrending = async () => {
      try {
        setIsLoading(true);
        const res = await fetchTrendingNews(100);
        if (res.success) {
          setItems(res.data || []);
        }
      } catch (err) {
        console.error("Failed to load trending news list:", err);
      } finally {
        setIsLoading(false);
      }
    };

    loadAllTrending();
  }, []);

  if (isLoading) {
    return (
      <div style={{ padding: "20px 0" }}>
        <LoadingPlaceholder rows={3} type="card" />
      </div>
    );
  }

  return (
    <>
      {items.map((item, index) => {
        const data = item.content || item;

        return (
          <div
            key={data.uuid || data.id || index}
            className="feed-item-wrapper"
          >
            <FeedNewCard
              id={data.uuid || data.id}
              title={data.title}
              description={data.description}
              date={data.new_date || data.date}
              image_url={data.image || data.image_url}
              source_link={data.source_link}
              source_name={data.source_name}
              likes={data.likes}
              dislikes={data.dislikes}
              loves={data.love || data.loves}
              userReaction={data.user_reaction}
              comments={data.comments}
            />
          </div>
        );
      })}
    </>
  );
}

export default TrendingNewsList;
